import { useParams } from 'react-router-dom';
import { PresentationsTab } from '../DemoPage/PresentationsTab';
import { ActivitiesTab } from './ActivitiesTab';
import { HistoryTab } from './HistoryTab';
import { LinksTab } from './LinksTab';
import { OverviewTab } from './OverviewTab';
import { SpeakerNotesTab } from './SpeakerNotesTab';
import type { TourPageProps } from './TourPageContext';
import { TourPageProvider } from './TourPageContext';
import { TourPageSidebar } from './TourPageSidebar';
import type { TourPageTab } from './types';

const componentByTabId = {
  overview: <OverviewTab />,
  presentations: <PresentationsTab />,
  links: <LinksTab />,
  activity: <ActivitiesTab />,
  history: <HistoryTab />,
  'speaker-notes': <SpeakerNotesTab />,
};

export const TourPage = (props: TourPageProps) => {
  const { tabId } = useParams<{ tabId: TourPageTab }>();

  return (
    <TourPageProvider {...props}>
      <div className="flex h-full w-full">
        <TourPageSidebar />
        <div className="grow shrink-0">{tabId && componentByTabId[tabId]}</div>
      </div>
    </TourPageProvider>
  );
};
